import script from "./MoneyLabel.vue?vue&type=script&lang=js"
export * from "./MoneyLabel.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__